function parseYourPayment(payments) {
  /*
    NOTE:

    amount = total + tip
    total = total before tip

    We use the transactionDateTime of the last payment
    to represent all payments in the UI.
  */

  const toDollars = value => Math.round(value * 100) / 100;

  return payments.reduce((result, payment) => {
    const total = toDollars(payment.amount - payment.tip);

    result.transactionDateTime = payment.transactionDateTime;
    result.amount = toDollars(result.amount + payment.amount);
    result.serviceCharges = toDollars(result.serviceCharges + payment.serviceCharges);
    if (payment.paymentType === 'CreditCard' && payment.surcharge) {
      result.surcharge = toDollars(result.surcharge + payment.surcharge);
    }
    result.storeFees = toDollars(result.storeFees + payment.storeFees);
    result.tax = toDollars(result.tax + payment.tax);
    result.tip = toDollars(result.tip + payment.tip);
    result.total = toDollars(result.total + total);

    result.payments.push({ ...payment, total });

    return result;
  }, {
    payments: [],
    amount: 0,
    serviceCharges: 0,
    surcharge: 0,
    storeFees: 0,
    tax: 0,
    tip: 0,
    total: 0
  });
}



export default parseYourPayment;
